import { PropertyFieldType } from '../../../../../../../../../BotProperties/components/Properties/types'

export const STRING = [
  PropertyFieldType.String,
  PropertyFieldType.Email,
  PropertyFieldType.Phone,
  PropertyFieldType.DateTime,
  PropertyFieldType.Date,
  PropertyFieldType.Time,
]

export const NUMBER = [
  PropertyFieldType.Number,
  PropertyFieldType.Double,
]

export const DATE_TIME = [
  PropertyFieldType.DateTime,
  PropertyFieldType.Date,
  PropertyFieldType.Time,
]

export const TIME = [
  PropertyFieldType.DateTime,
  PropertyFieldType.Time,
]

export const DATE = [
  PropertyFieldType.DateTime,
  PropertyFieldType.Date,
]
